import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "../../ts/GlobalSetting";


declare global
{
  interface Window
  {
    initMap: () => void;
  }
}

const callbackList: Function[] = [];
let _isLibLoaded = false,
  _isScriptBind = false;

function registCallback(cb: Function)
{
  callbackList.push(cb);
}

function initMap(): void
{
  // console.log("google map lib loaded");

  _isScriptBind = true;
  _isLibLoaded = true;
  callbackList.forEach((callback: Function) =>
  {
    callback.call(null);
  });
}
window.initMap = initMap;

export default class GoogleMap extends ComponentBase
{
  map: google.maps.Map;

  constructor(elem: ComponentElem)
  {
    super(elem);

    // console.log(_isLibLoaded);
    if(!_isScriptBind)
    {
      let tag = $(`<script src="https://maps.googleapis.com/maps/api/js?key=${GS.setting.googleMapKey}&callback=initMap&v=weekly" defer></script>`);
      $("head").append(tag);
      
      _isScriptBind = true;
    }
    
    _isLibLoaded ? this.build() : registCallback(() => { this.build(); });
  }

  build()
  {
    this.map = new google.maps.Map(this.$root[0] as HTMLElement, {
      center: { lat: 23.8680565, lng: 121.0115024 },
      zoom: 7,
    });

    let address = this.$root.attr("data-address"),
      label = this.$root.attr("data-label"),
      lat = this.$root[0].dataset.lat,
      lng = this.$root[0].dataset.lng;

      // console.log("label: " + label);
      
    // if(label === undefined) label = address;
    if(label === undefined) label = "";

    if(lat !== undefined && lng !== undefined)
    {      
      var latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      this.setCenter(latlng, label);
      return;
    }

    let geocoder = new google.maps.Geocoder();

    geocoder.geocode( { 'address': address}, (results, status)=> {
      if (status == 'OK') {        
        this.setCenter(results[0].geometry.location, label)
        
      } else {
        console.log(status);
      }
    });
  }

  setCenter(latlng: google.maps.LatLng, label: string = "")
  {
    // var latlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng))
        
    this.map.setCenter(latlng);
    this.map.setZoom(17);

    if(label)
    {
      new google.maps.Marker({
          map: this.map,
          position: latlng,            
          label: {
            text: label,
            className: 'google-map-marker-label'
        }
      });

    }
  }
}